<template>
  <div></div>
</template>
<script>
export default {
  props:{
    archiveId: {
      type: [String, Number],
      required: true,
    },
    seoName: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      items: [
        {archiveId: 1480, newId: 2947},
        {archiveId: 1481, newId: 2950},
        {archiveId: 1482, newId: 2953},
        {archiveId: 1483, newId: 2956},
        {archiveId: 1484, newId: 2959},
        {archiveId: 1485, newId: 2962},
        {archiveId: 1486, newId: 2965},
        {archiveId: 1487, newId: 2968},
        {archiveId: 1488, newId: 2971},
        {archiveId: 1489, newId: 2974},
        {archiveId: 1490, newId: 2977},
        {archiveId: 1491, newId: 2980},
        {archiveId: 1492, newId: 2983},
        {archiveId: 1493, newId: 2986},
        {archiveId: 1494, newId: 2989},
        {archiveId: 1495, newId: 2992},
        {archiveId: 1496, newId: 2995},
        {archiveId: 1497, newId: 2998},
        {archiveId: 1499, newId: 3001},
        {archiveId: 1500, newId: 3004},
        {archiveId: 1501, newId: 3007},
        {archiveId: 1502, newId: 3010},
        {archiveId: 1503, newId: 3013},
        {archiveId: 1504, newId: 3016},
        {archiveId: 1505, newId: 3019},
        {archiveId: 1506, newId: 3022},
        {archiveId: 1507, newId: 3025},
        {archiveId: 1508, newId: 3028},
        {archiveId: 1509, newId: 3031},
        {archiveId: 1510, newId: 3034},
        {archiveId: 1512, newId: 3037},
        {archiveId: 1513, newId: 3040},
        {archiveId: 1514, newId: 3043},
        {archiveId: 1515, newId: 3046},
        {archiveId: 1516, newId: 3049},
        {archiveId: 1551, newId: 3052},
        {archiveId: 1740, newId: 3055},
        {archiveId: 1741, newId: 3058},
        {archiveId: 1831, newId: 3061},
        {archiveId: 1861, newId: 3064},
        {archiveId: 1864, newId: 3067},
        {archiveId: 1960, newId: 3070},
        {archiveId: 1962, newId: 3073},
        {archiveId: 1963, newId: 3076},
        {archiveId: 1988, newId: 3079},
        {archiveId: 2026, newId: 3082},
        {archiveId: 2032, newId: 3085},
        {archiveId: 2034, newId: 3088},
        {archiveId: 2037, newId: 3091},
        {archiveId: 2038, newId: 3094},
        {archiveId: 2039, newId: 3097},
        {archiveId: 2045, newId: 3100},
        {archiveId: 2063, newId: 3103},
        {archiveId: 2064, newId: 3106},
        {archiveId: 2066, newId: 3109},
        {archiveId: 2067, newId: 3112},
        {archiveId: 2096, newId: 3115},
        {archiveId: 2149, newId: 3118},
        {archiveId: 2152, newId: 3121},
        {archiveId: 2157, newId: 3124},
        {archiveId: 2180, newId: 3127},
        {archiveId: 2204, newId: 3130},
        {archiveId: 2316, newId: 3133},
        {archiveId: 2321, newId: 3136},
        {archiveId: 2323, newId: 3139},
        {archiveId: 2324, newId: 3142},
        {archiveId: 2325, newId: 3145},
        {archiveId: 2326, newId: 3148},
        {archiveId: 2328, newId: 3151},
        {archiveId: 2329, newId: 3154},
        {archiveId: 2330, newId: 3157},
        {archiveId: 2331, newId: 3160},
        {archiveId: 2332, newId: 3163},
        {archiveId: 2333, newId: 3166},
        {archiveId: 2338, newId: 3169},
        {archiveId: 2339, newId: 3172},
        {archiveId: 2340, newId: 3175},
        {archiveId: 2341, newId: 3178},
        {archiveId: 2342, newId: 3181},
        {archiveId: 2343, newId: 3184},
        {archiveId: 2367, newId: 3187},
        {archiveId: 2444, newId: 3190},
        {archiveId: 2495, newId: 3193},
        {archiveId: 2545, newId: 3196},
        {archiveId: 2602, newId: 3199},
        {archiveId: 2778, newId: 3202},
        {archiveId: 2796, newId: 3205},
        {archiveId: 2803, newId: 3208},
        {archiveId: 2804, newId: 3211},
        {archiveId: 2837, newId: 3214},
        {archiveId: 2838, newId: 3217},
        {archiveId: 2839, newId: 3220},
        {archiveId: 2840, newId: 3223},
        {archiveId: 2841, newId: 3226},
        {archiveId: 2842, newId: 3229},
        {archiveId: 2879, newId: 3232},
        {archiveId: 2887, newId: 3235},
        {archiveId: 2923, newId: 3238},
        {archiveId: 2974, newId: 3241},
        {archiveId: 2985, newId: 3244},
        {archiveId: 2991, newId: 3247},
        {archiveId: 3084, newId: 3250},
        {archiveId: 3163, newId: 3253},
        {archiveId: 3168, newId: 3256},
        {archiveId: 3246, newId: 3259},
        {archiveId: 3249, newId: 3262},
        {archiveId: 3260, newId: 3265},
        {archiveId: 3273, newId: 3268},
        {archiveId: 3275, newId: 3271},
        {archiveId: 3280, newId: 3274},
        {archiveId: 3310, newId: 3277},
        {archiveId: 3319, newId: 3280},
        {archiveId: 3326, newId: 3283},
        {archiveId: 3327, newId: 3286},
        {archiveId: 3330, newId: 3289},
        {archiveId: 3331, newId: 3292},
        {archiveId: 3332, newId: 3295},
        {archiveId: 3333, newId: 3298},
        {archiveId: 3334, newId: 3301},
        {archiveId: 3335, newId: 3304},
        {archiveId: 3336, newId: 3307},
        {archiveId: 3337, newId: 3310},
        {archiveId: 3338, newId: 3313},
        {archiveId: 3339, newId: 3316},
        {archiveId: 3340, newId: 3319},
        {archiveId: 3341, newId: 3322},
        {archiveId: 3342, newId: 3325},
        {archiveId: 3343, newId: 3328},
        {archiveId: 3345, newId: 3331},
        {archiveId: 3347, newId: 3334},
        {archiveId: 3349, newId: 3337},
        {archiveId: 3350, newId: 3340},
        {archiveId: 3351, newId: 3343},
        {archiveId: 3352, newId: 3346},
        {archiveId: 3353, newId: 3349},
        {archiveId: 3354, newId: 3352},
        {archiveId: 3355, newId: 3355},
        {archiveId: 3356, newId: 3358},
        {archiveId: 3357, newId: 3361},
        {archiveId: 3358, newId: 3364},
        {archiveId: 3359, newId: 3367},
        {archiveId: 3360, newId: 3370},
        {archiveId: 3361, newId: 3373},
        {archiveId: 3362, newId: 3376},
        {archiveId: 3371, newId: 3379},
        {archiveId: 3372, newId: 3382},
        {archiveId: 3373, newId: 3385},
      ]
    }
  },
  created() {
    console.log(this.archiveId);
    let filtered = this.items.filter((item) => {
      return item.archiveId == this.archiveId;
    });
    if (filtered.length > 0) {
      if (this.seoName) {
        this.$router.push({name: 'StreamWithSeoName', params: { id: filtered[0].newId, seoName: this.seoName }});
      } else {
        this.$router.push({name: 'Stream', params: { id: filtered[0].newId }});
      }
    } else {
      this.$router.push({ name: 'Broadcasts' });
      let snackbar = {
        color: 'error',
        timeout: 3000,
        text: `The archived broadcast could not be found.`
      };
      this.$store.dispatch('addSnackbar', snackbar);
      this.$gtag.experience('error_archived_not_found', this.archiveId);
    }
  }
}
</script>